
<template>
  <div class="menu-container">
    <div id="overlay" v-if="menu" @click="menu = !menu"></div>
    <section id="menu">
      <header>
        <div class="menu-header">
          <active-user-icon title="" />
          <span class="description">
            <div class="user-name">{{ activeUser }}</div>
            <div class="local">{{ local }}</div>
          </span>
        </div>
        <div
          v-if="userGroup && !['null', 'undefined'].includes(userGroup)"
          class="menu-header"
        >
          <user-group-icon title="" />
          <span class="description">
            <div class="user-name">{{ userGroup }}</div>
            <div class="local">{{ local }}</div>
          </span>
        </div>
        <b-button v-b-toggle="'collapse-a'" class="button-menu" v-toggle>
          <div class="title-nav">
            <settings-outline-icon title="" />
            <span>CONFIGURAÇÃO</span>
          </div
          >
          <arrow-down-icon class="arrow"
        /></b-button>

        <b-collapse id="collapse-a" class="config-list" @click="menu = !menu">
          <router-link v-for="item in items" :key="item.link" :to="item.link" exact-active-class="active-link">
            <li :title="item.description">{{ item.title }}</li>
          </router-link>
        </b-collapse>
        <div class="at-bottom mt-2">
          <b-btn block variant="light" @click="$emit('logout')"> Sair </b-btn>
        </div>
      </header>
    </section>
  </div>
</template>

<script>
export default {
  name: "sideNav",
  props: {
    isAdmin: Boolean,
    userGroup: [String],
    activeUser: [String],
    local: [String],
    shown: [Boolean],
  },
  directives:{
    toggle:{
      bind:function(el){
        el.addEventListener('click',()=>{
          let arrowIcon=el.querySelector('.arrow')
          arrowIcon.classList.toggle('rotateArrow')
        })
      }
    }
  },
  data() {
    return {
      menu: false,

      items: [
        {
          link: "/config/network",
          title: "rede",
          description: "Configure conexão de rede e o rádio",
        },
        {
          link: "/config/logs",
          title: "logs",
          description: "Informações do sistema, servidor e firmware",
        },
        {
          link: "/config/map",
          title: "mapa",
          description: "Configure localização, url do mapa e kml",
        },
        {
          link: "/config/general",
          title: "ajustes",
          description: "Configurações gerais do dispositivo e data do sistema",
        },
        {
          link: "/config/reset",
          title: "resets",
          description: "Reinicie ou desligue o CIR",
        },
        {
          link: "/config/advanced",
          title: "avançado",
          description:
            "Informações auxiliares para sensores e modelos de sensor",
        },
        {
          link: "/config/management",
          title: "Manejo",
          description:
            "Configurações gerais de manejo",
        },
      ],
    };
  },
  watch: {
    shown(newValue, oldValue) {
      this.menu = newValue;
    },
    menu(newValue, oldValue) {
      if (oldValue != newValue) this.$emit("toggle-menu", newValue);
      if (newValue) {
        document.getElementById("menu").style.width = "240px";
        document.getElementById("menu").style.padding = "10px 15px";
        document.getElementById("menu").style.overflow = "auto";
      } else {
        document.getElementById("menu").style.padding = "0";
        document.getElementById("menu").style.width = "0";
        document.getElementById("menu").style.overflow = "hidden";
      }
    },
  },

};
</script>

<style scoped>
.menu-container{
  position: relative;
}
.at-bottom{
  position: absolute;
  bottom: 80px;
  left: 12px;
  right: 0px;
  width: 90%;
}
#overlay {
  position: fixed;
  top: 55px;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 99999;
  background-color: rgba(0, 0, 0, 0.5);
  overflow: hidden;
}
.rotateArrow{
  margin-top: 6px;
  transform: rotate(180deg);
}
.active-link{
  font-family: 'SourceSansPro_Bold';
   text-decoration: underline;
   text-decoration-color:#cdcfce;

}
.arrow{
  position:absolute;
  right: 5px;
}
.title-nav {
  display: flex;
  align-items: center;
}
.title-nav .material-design-icon {
  margin-right: 5px;
}
.button-menu {
  position: relative;
  background: #2e493a;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;
  padding: 8px;
  margin-bottom: 4px;
  width: 100%;
  outline: none;
  border-style: none;
}

.button-menu .material-design-icon {
  margin-bottom: 5px;
}
#menu {
  box-sizing: border-box;
  position: fixed;
  top: 55px;
  left: 0;
  width: 0;
  height: 100%;
  z-index: 999999;
  overflow: hidden;
  color: var(--white-color-primary);
  background-color: var(--green-3v3-second);
  transition: 0.1s;
  padding: 0;
}
.description {
  line-height: 1.2em;
  margin-left: 8px;
  margin-top: 3px;
}
.user-name {
  font-size: 1.3em;
  font-family: 'SourceSansPro_Semibold';
}
.local {
  font-size: 0.7em;
}
.menu-header {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  background: #2e493a;
  border-radius: 4px;
  padding: 4px;
  margin-bottom: 4px;
}
.menu-header .material-design-icon {
  margin-top: -3px;
  font-size: 2.5em;
  margin-bottom: 7px;
}

/* #menu h4 {
    font-size: 1.4em;
    border-bottom: 1px solid #fff;
    padding-bottom: 8px;
    text-align: center;
  } */
#menu h5 {
  font-size: 1em;
  font-variant: small-caps;
  /* font-weight: 100; */
}
#menu .material-design-icon {
  vertical-align: -3.5px;
}
.config-list {
  margin-top: 7px;
  text-transform: uppercase;
  margin-left: 12px;
  border-left: 1px solid #fff;
  padding-left: 10px;
  list-style: none;
}
.config-list li {
  color: var(--white-color-primary);
  padding: 6px 5px;
  transition: 0.2s;
}
.config-list li:hover {
  color: #e4e4e4;
}
</style>
